import { lbBrand } from '@fuse/colors';
import { routesUrl } from 'app/fuse-configs/navigationConfig';
import { ChecklistGroup, ChecklistItemType, HomeVideoSection, LaunchTaskType } from './types';

export const HOME_OBJECTIVE_PATH = (storeId: string) => `api/v2/stores/${storeId}/home-objective`;
export const HOME_LAUNCH_TASKS_PATH = (storeId: string) => `${HOME_OBJECTIVE_PATH(storeId)}/launch-tasks`;
export const HOME_VIDEOS_PATH = 'api/v2/home-videos';
export const ADMIN_HOME_OBJECTIVE_PATH = 'api/v2/admin/home-objective';
export const ADMIN_HOME_VIDEOS_PATH = 'api/v2/admin/home-videos';

export const CHECKLIST_ITEM_ORDER: ChecklistItemType[] = Object.values(ChecklistItemType);

export const CHECKLIST_GROUP_ORDER: ChecklistGroup[] = [
  ChecklistGroup.LOYALTY,
  ChecklistGroup.BOOST,
  ChecklistGroup.REACH,
];

export const MAX_PERCENTAGE = 100;

type ChecklistItemMeta = {
  /** Where the arrow leads. */
  url?: string;
  /** The target page is open to franchise owners only. */
  franchiseOwnerOnly?: boolean;
  /** The item has a number the admin can change. */
  hasThreshold: boolean;
  /** The threshold and the progress are percentages. */
  isPercentage?: boolean;
};

export const CHECKLIST_ITEM_META: Record<ChecklistItemType, ChecklistItemMeta> = {
  [ChecklistItemType.CAMPAIGN_SENT]: { url: routesUrl.campaignCreation, hasThreshold: true },
  [ChecklistItemType.NEW_CLIENTS_RETURN]: {
    url: routesUrl.marketingList,
    franchiseOwnerOnly: true,
    hasThreshold: true,
    isPercentage: true,
  },
  [ChecklistItemType.AUTOMATED_MARKETING_RETURN]: {
    url: routesUrl.marketingList,
    franchiseOwnerOnly: true,
    hasThreshold: true,
    isPercentage: true,
  },
  [ChecklistItemType.REFERRAL]: { url: routesUrl.referral, hasThreshold: true },
  [ChecklistItemType.GIFT_WHEEL_REVIEWS]: { url: routesUrl.gamesCreation, hasThreshold: true },
  [ChecklistItemType.DIRECTORIES_SYNCED]: { url: routesUrl.visibilitySettings, hasThreshold: true },
  [ChecklistItemType.GOOGLE_POST]: { url: routesUrl.visibilityPosts, hasThreshold: false },
};

export const LAUNCH_TASK_META: Record<LaunchTaskType, { url?: string }> = {
  [LaunchTaskType.GOOGLE_REVIEW_LINK]: { url: routesUrl.stores },
  [LaunchTaskType.A5_POSTER]: { url: routesUrl.loyalties },
  [LaunchTaskType.SOCIAL_PROMO]: { url: routesUrl.eMarketingPage },
  [LaunchTaskType.TEAM_PITCH_TRAINING]: {},
  [LaunchTaskType.NFC_TAG_TRAINING]: {},
};

export const VIDEO_SECTION_ORDER: HomeVideoSection[] = [
  HomeVideoSection.OFFERS_NEWS,
  HomeVideoSection.TRAINING,
  HomeVideoSection.TESTIMONIALS,
];

export const VIDEO_SECTION_COLORS: Record<HomeVideoSection, string> = {
  [HomeVideoSection.OFFERS_NEWS]: lbBrand.red,
  [HomeVideoSection.TRAINING]: lbBrand.darkGray,
  [HomeVideoSection.TESTIMONIALS]: lbBrand.redDark,
};

export const youtubeThumbnailUrl = (youtubeId: string) => `https://i.ytimg.com/vi/${youtubeId}/hqdefault.jpg`;

export const youtubeEmbedUrl = (youtubeId: string) =>
  `https://www.youtube-nocookie.com/embed/${youtubeId}?autoplay=1&rel=0`;
